import { type BaseUrl } from 'services'
import { URL_DESC_TYPES, URL_TYPES } from 'utils'

export const isImageLogo = (value: BaseUrl): boolean => value.descId === URL_DESC_TYPES.IMAGE_LOGO
export const isSource = (value: BaseUrl): boolean => value.descId === URL_DESC_TYPES.SOURCE
export const isEmail = (value: BaseUrl): boolean => value.descId === URL_DESC_TYPES.EMAIL || value.descId === URL_DESC_TYPES.EMAIL_WEBFORM
export const isEmailUs = (value: BaseUrl): boolean => value.typeId === URL_TYPES.EMAIL.id
